// src/pages/admin/components/RichTextWithTemplates.jsx

import React from 'react';
import RichText from './RichText';

// Шаблоны описаний для разных типов недвижимости
const DESCRIPTION_TEMPLATES = {
  apartment: {
    name: 'Квартира',
    templates: [
      {
        name: 'Стандартная квартира',
        content: `<h3>Описание квартиры</h3>
<p>Предлагаем к продаже просторную квартиру в современном жилом комплексе. Квартира расположена на [этаж] этаже [количество этажей]-этажного дома.</p>

<h3>Планировка и площадь</h3>
<p>Общая площадь составляет [площадь] кв.м, жилая площадь - [жилая площадь] кв.м. Квартира имеет [количество комнат] комнат(ы), просторную кухню площадью [площадь кухни] кв.м.</p>

<h3>Особенности</h3>
<ul>
<li>Современная отделка</li>
<li>Панорамные окна</li>
<li>Встроенная техника</li>
<li>Система кондиционирования</li>
</ul>

<h3>Инфраструктура</h3>
<p>В шаговой доступности находятся школы, детские сады, торговые центры, парки и остановки общественного транспорта.</p>`
      },
      {
        name: 'Премиум квартира',
        content: `<h3>Эксклюзивная квартира премиум-класса</h3>
<p>Представляем роскошную квартиру в престижном районе с безупречной репутацией. Недвижимость отличается высочайшим качеством отделки и продуманной планировкой.</p>

<h3>Преимущества расположения</h3>
<p>Квартира находится в элитном жилом комплексе с развитой инфраструктурой и круглосуточной охраной. Из окон открывается потрясающий вид на [вид из окон].</p>

<h3>Эксклюзивные особенности</h3>
<ul>
<li>Дизайнерская отделка от известных брендов</li>
<li>Система "умный дом"</li>
<li>Индивидуальная планировка</li>
<li>Собственная парковка</li>
<li>Консьерж-сервис</li>
</ul>

<h3>Инвестиционная привлекательность</h3>
<p>Данная недвижимость представляет отличную возможность для инвестиций благодаря престижному расположению и высокому потенциалу роста стоимости.</p>`
      }
    ]
  },
  foreign: {
    name: 'Зарубежная недвижимость',
    templates: [
      {
        name: 'Зарубежная квартира',
        content: `<h3>Недвижимость за рубежом</h3>
<p>Предлагаем к приобретению недвижимость в [страна], [город]. Объект расположен в престижном районе с развитой инфраструктурой и отличной транспортной доступностью.</p>

<h3>Характеристики объекта</h3>
<p>Площадь: [площадь] кв.м<br>
Количество комнат: [комнаты]<br>
Этаж: [этаж] из [всего этажей]<br>
Год постройки: [год]</p>

<h3>Преимущества локации</h3>
<ul>
<li>Близость к морю/центру города</li>
<li>Развитая туристическая инфраструктура</li>
<li>Высокий инвестиционный потенциал</li>
<li>Возможность получения ВНЖ</li>
</ul>

<h3>Дополнительные услуги</h3>
<p>Мы предоставляем полное сопровождение сделки, помощь в оформлении документов и получении ВНЖ. Возможна организация просмотра объекта.</p>`
      },
      {
        name: 'Инвестиционная недвижимость',
        content: `<h3>Инвестиционная недвижимость за рубежом</h3>
<p>Уникальная возможность инвестирования в недвижимость [страна] с гарантированной доходностью и перспективами роста капитала.</p>

<h3>Инвестиционные преимущества</h3>
<ul>
<li>Гарантированная доходность [процент]% годовых</li>
<li>Рост стоимости недвижимости в регионе</li>
<li>Возможность получения гражданства</li>
<li>Стабильная экономическая ситуация</li>
</ul>

<h3>Программа инвестирования</h3>
<p>Минимальная сумма инвестиций: [сумма]<br>
Срок окупаемости: [срок] лет<br>
Возможность рассрочки: до [срок рассрочки] месяцев</p>

<h3>Юридическое сопровождение</h3>
<p>Полное юридическое сопровождение сделки, оформление всех необходимых документов, консультации по налогообложению.</p>`
      }
    ]
  },
  suburban: {
    name: 'Загородная недвижимость',
    templates: [
      {
        name: 'Загородный дом',
        content: `<h3>Загородный дом для комфортной жизни</h3>
<p>Предлагаем к продаже уютный загородный дом в экологически чистом районе. Идеальное место для постоянного проживания или отдыха на природе.</p>

<h3>Характеристики дома</h3>
<p>Общая площадь дома: [площадь дома] кв.м<br>
Площадь участка: [площадь участка] соток<br>
Количество этажей: [этажи]<br>
Материал стен: [материал]</p>

<h3>Планировка и удобства</h3>
<ul>
<li>Просторная гостиная с камином</li>
<li>Современная кухня-столовая</li>
<li>Спальни с гардеробными</li>
<li>Санузлы с современной сантехникой</li>
<li>Терраса/веранда для отдыха</li>
</ul>

<h3>Участок и инфраструктура</h3>
<p>Благоустроенный участок с ландшафтным дизайном, место для парковки, хозяйственные постройки. Все коммуникации подведены.</p>`
      },
      {
        name: 'Дача/Коттедж',
        content: `<h3>Уютная дача в живописном месте</h3>
<p>Отличная возможность приобрести дачу в тихом, экологически чистом районе. Идеально подходит для семейного отдыха и выращивания собственных овощей и фруктов.</p>

<h3>Описание строений</h3>
<p>На участке расположены:<br>
- Жилой дом [площадь] кв.м<br>
- Баня/сауна<br>
- Хозяйственные постройки<br>
- Гараж/навес для автомобиля</p>

<h3>Особенности участка</h3>
<ul>
<li>Плодовые деревья и кустарники</li>
<li>Огород с теплицами</li>
<li>Зона отдыха с мангалом</li>
<li>Собственная скважина</li>
<li>Электричество 220/380В</li>
</ul>

<h3>Транспортная доступность</h3>
<p>Удобный подъезд к участку, [расстояние] км от города, регулярное автобусное сообщение.</p>`
      }
    ]
  },
  commercial: {
    name: 'Коммерческая недвижимость',
    templates: [
      {
        name: 'Офисное помещение',
        content: `<h3>Офисное помещение в бизнес-центре</h3>
<p>Предлагаем в аренду современное офисное помещение в престижном бизнес-центре класса А. Идеально подходит для размещения офиса компании любого масштаба.</p>

<h3>Характеристики помещения</h3>
<p>Общая площадь: [площадь] кв.м<br>
Этаж: [этаж] из [всего этажей]<br>
Планировка: [планировка]<br>
Состояние: [состояние]</p>

<h3>Преимущества расположения</h3>
<ul>
<li>Центральное расположение</li>
<li>Отличная транспортная доступность</li>
<li>Престижный деловой район</li>
<li>Развитая инфраструктура</li>
</ul>

<h3>Инфраструктура бизнес-центра</h3>
<ul>
<li>Круглосуточная охрана</li>
<li>Современные лифты</li>
<li>Система кондиционирования</li>
<li>Подземная парковка</li>
<li>Кафе и рестораны</li>
</ul>`
      },
      {
        name: 'Торговое помещение',
        content: `<h3>Торговое помещение в проходном месте</h3>
<p>Отличная возможность для развития торгового бизнеса! Предлагаем помещение с высокой проходимостью в центре торговой активности.</p>

<h3>Коммерческие характеристики</h3>
<p>Площадь: [площадь] кв.м<br>
Тип помещения: [тип]<br>
Высота потолков: [высота] м<br>
Витринные окна: [количество] м</p>

<h3>Преимущества для бизнеса</h3>
<ul>
<li>Высокий пешеходный трафик</li>
<li>Удобная парковка для клиентов</li>
<li>Близость к транспортным узлам</li>
<li>Развитая торговая инфраструктура</li>
</ul>

<h3>Техническое оснащение</h3>
<p>Все необходимые коммуникации, возможность подключения дополнительных мощностей, система вентиляции и кондиционирования.</p>`
      }
    ]
  },
  parking: {
    name: 'Парковочные места',
    templates: [
      {
        name: 'Машиноместо в паркинге',
        content: `<h3>Машиноместо в охраняемом паркинге</h3>
<p>Предлагаем к продаже удобное машиноместо в современном многоуровневом паркинге. Отличное решение для безопасного хранения автомобиля.</p>

<h3>Характеристики места</h3>
<p>Номер места: [номер]<br>
Уровень: [уровень]<br>
Размеры: [размеры] м<br>
Тип: [тип паркинга]</p>

<h3>Преимущества паркинга</h3>
<ul>
<li>Круглосуточная охрана</li>
<li>Система видеонаблюдения</li>
<li>Удобный въезд/выезд</li>
<li>Освещение и вентиляция</li>
<li>Близость к жилому комплексу</li>
</ul>

<h3>Дополнительные услуги</h3>
<p>Возможность аренды дополнительного места для гостей, услуги автомойки и технического обслуживания.</p>`
      },
      {
        name: 'Гараж',
        content: `<h3>Капитальный гараж в гаражном кооперативе</h3>
<p>Продается капитальный гараж в охраняемом гаражном кооперативе. Подходит как для хранения автомобиля, так и для мастерской или склада.</p>

<h3>Технические характеристики</h3>
<p>Площадь: [площадь] кв.м<br>
Высота: [высота] м<br>
Материал: [материал]<br>
Ворота: [тип ворот]</p>

<h3>Оснащение гаража</h3>
<ul>
<li>Электричество 220В</li>
<li>Смотровая яма</li>
<li>Стеллажи для инструментов</li>
<li>Вентиляция</li>
<li>Охранная сигнализация</li>
</ul>

<h3>Инфраструктура кооператива</h3>
<p>Охрана территории, удобные подъездные пути, возможность круглосуточного доступа.</p>`
      }
    ]
  }
};

export default function RichTextWithTemplates({
  value = '',
  onChange,
  placeholder = 'Введите описание…',
  minHeight = 160,
  propertyType = 'apartment' // apartment, foreign, suburban, commercial, parking
}) {
  const [showTemplates, setShowTemplates] = React.useState(false);
  
  const templates = DESCRIPTION_TEMPLATES[propertyType]?.templates || DESCRIPTION_TEMPLATES.apartment.templates;
  const typeName = DESCRIPTION_TEMPLATES[propertyType]?.name || 'Недвижимость';

  const applyTemplate = (template) => {
    onChange?.(template.content);
    setShowTemplates(false);
  };

  return (
    <div>
      {/* Кнопка выбора шаблона */}
      <div style={{ marginBottom: 8 }}>
        <button
          type="button"
          className="btn"
          onClick={() => setShowTemplates(!showTemplates)}
          style={{
            backgroundColor: showTemplates ? 'var(--primary)' : 'var(--card)',
            color: showTemplates ? 'var(--primaryFg)' : 'inherit'
          }}
        >
          Выбрать шаблон описания
        </button>
        {showTemplates && (
          <span style={{ marginLeft: 8, color: 'var(--muted)', fontSize: 12 }}>
            Шаблоны для: {typeName}
          </span>
        )}
      </div>

      {/* Выпадающий список шаблонов */}
      {showTemplates && (
        <div style={{
          marginBottom: 12,
          padding: 12,
          border: '1px solid var(--bdr)',
          borderRadius: 8,
          backgroundColor: 'var(--card)',
          boxShadow: 'var(--shadow)'
        }}>
          <div style={{ marginBottom: 8, fontWeight: 600, color: 'var(--primary)' }}>
            Выберите шаблон описания:
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {templates.map((template, index) => (
              <button
                key={index}
                type="button"
                onClick={() => applyTemplate(template)}
                style={{
                  padding: '8px 12px',
                  border: '1px solid var(--bdr)',
                  borderRadius: 6,
                  backgroundColor: 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f5f5f5';
                  e.target.style.borderColor = 'var(--primary)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = 'var(--bdr)';
                }}
              >
                <div style={{ fontWeight: 600, marginBottom: 4 }}>
                  {template.name}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                  {template.content.replace(/<[^>]+>/g, ' ').substring(0, 100)}...
                </div>
              </button>
            ))}
          </div>
          <div style={{ marginTop: 8, textAlign: 'right' }}>
            <button
              type="button"
              className="btn"
              onClick={() => setShowTemplates(false)}
              style={{ fontSize: 12 }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}

      {/* Основной редактор */}
      <RichText
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        minHeight={minHeight}
      />
    </div>
  );
}